<template>
  <div class="level_table small_table">
    <div
      class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition table"
    >
      <table cellspacing="0" cellpadding="0" border="0" width="100%">
        <thead>
          <tr class="dec" align="left">
            <td v-for="(item, index) in twoLevel" :key="index">
              <span>{{ item }}</span>
            </td>
          </tr>
        </thead>
        <!-- v-if="!noData" -->
        <tbody
          v-if="Object.keys(tableInfo).length"
          class="el-table__body"
          v-loading="loading"
          element-loading-background="#FFF"
          element-loading-spinner="el-icon-loading"
          element-loading-customClass="oneTheadLoading"
          element-loading-text="拼命的加载中"
        >
          <tr
            class="hover-row"
            v-for="(item, index) in getInfo.list"
            :key="index"
          >
            <td>{{ item.timeString }}</td>
            <td>{{ item.custName }}</td>
            <td>{{ item.custMobile }}</td>
            <td>{{ item.storeName }}</td>
            <td v-if="item.cardType === 1">储值卡</td>
            <td v-if="item.cardType === 2">次卡</td>
            <td v-else></td>
            <td>{{ item.cardName }}</td>
            <td>{{ item.orderNO }}</td>
            <td>{{ item.consumeMoney }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <nodata-table v-if="!Object.keys(tableInfo).length" />
    <slot v-if="getInfo.pagecount >= 2"></slot>
  </div>
</template>

<script>
import * as consts from "../../../common/const";
import * as queryUtil from "../../../common/query";
import NodataTable from "../../common/table/nodata_table";

export default {
  components: {
    NodataTable
  },
  props: {
    tableInfo: {
      type: Object,
      default: function() {
        return {};
      }
    },
    loading: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  data() {
    return {
      changeInfo: this.tableInfo,
      noData: true
    };
  },
  computed: {
    getInfo() {
      if (
        queryUtil.filterType(this.tableInfo.tableData) &&
        queryUtil.filterType(this.tableInfo.tableData.data)
      ) {
        this.noData = false;
      } else {
        this.noData = true;
      }
      return this.tableInfo;
    },
    twoLevel() {
      return consts.QUERY_TABLE.nofill.title;
    }
  }
};
</script>

<style lang="less" scoped>
.level_table {
  padding: 20px 0 30px !important;
  .el-table--border {
    border: none;
    border-top: 1px solid #e9e9f0;
  }
  table .dec {
    .cell {
      padding: 0;
      line-height: 40px;
    }
  }
  table tr td {
    border-right: none;
  }
  .el-table__body {
    tr td {
      // width: 6%;
    }
    tr td:nth-of-type(1) {
      // width: 7%;
      color: #666666;
    }
    tr td:nth-of-type(7) {
      // width: 14%;
      line-height: 20px;
      padding: 10px 16px;
    }
  }
}
</style>
